import { BUTTON_SIZES, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';

export const SAVE_SETTINGS_MODAL_TEXT = {
  modalId: 'save-settings-modal',
  saveButtonText: 'Save',
  title: 'Save changes?',
};

type SaveSettingsModalProps = {
  onSave: () => void;
};

export const SaveSettingsModal = ({ onSave }: SaveSettingsModalProps) => {
  const { hideModal } = useModalContext();
  return (
    <Modal
      id={SAVE_SETTINGS_MODAL_TEXT.modalId}
      isModalOpen
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
      withPortal
    >
      <ModalHeader onClose={hideModal} autoFocus={false}>
        {SAVE_SETTINGS_MODAL_TEXT.title}
      </ModalHeader>
      <ModalBody>
        Changing event and field lock settings impacts API behavior, and can result in unintended
        data loss or data pollution. Are you sure you want to continue saving?
      </ModalBody>
      <ModalFooter onClose={hideModal}>
        <Button onClick={onSave} size={BUTTON_SIZES.LARGE}>
          {SAVE_SETTINGS_MODAL_TEXT.saveButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
